import React, { Component } from 'react';
import { authenticationCentral } from '../authentication/Authentication';
import { storage, TOKEN_INFO, TOKEN_EXPIRATION, PROFILE_INFO, REDIRECT_TO } from '../app/Storage';
import { decode } from 'jsonwebtoken';
import { HandleMessage } from './HandleMessage';

export class AuthenticationCallback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: undefined
        };
    }

    onHideErrorMessage() {
        window.location.href = '/';
    }

    componentDidMount() {
        let tokenInfo = undefined;
        authenticationCentral.parseUrl(window.location.href)
            .then((authorizationCode) => {
                return authenticationCentral.getToken({
                    authorization_code: authorizationCode
                });
            }).then((res) => {
                // Authenticated, get profile info
                return authenticationCentral.getProfileInfo();
            }).then((res) => {
                tokenInfo = storage.get(TOKEN_INFO);
                if ('undefined' !== typeof tokenInfo) {
                    var json = JSON.parse(tokenInfo);
                    tokenInfo = Object.assign({}, json);
                }

                if (tokenInfo.id_token) {
                    let idToken = decode(tokenInfo.id_token);

                    if (!idToken.apps) {
                        throw Error("Nenhuma aplicação disponivel!");
                    }
                }

                // Redirect to the homepage
                // FIXME there must be a better way to redirect to the homepage
                let redirectTo = storage.get(REDIRECT_TO);
                storage.remove(REDIRECT_TO);
                if (redirectTo !== undefined) {
                    window.location.href = redirectTo;
                } else {
                    window.location.href = '/';
                }
            }).catch((error) => {
                // Could not authenticate 
                // Should erase all login information and start over
                storage.remove(TOKEN_INFO);
                storage.remove(TOKEN_EXPIRATION);
                storage.remove(PROFILE_INFO);
                storage.remove(REDIRECT_TO);

                if (undefined === tokenInfo) {
                    window.location.href = '/';
                } else {
                    this.setState({
                        error: error.message || ""
                    });
                }
            });
    }

    render() {
        const { error } = this.state;

        if (undefined === error) {
            return (
                <div />
            );
        }

        return (
            <HandleMessage message={error}
                title="Erro"
                icon="remove"
                style={`danger`}
                show={true}
                buttonText="TENTAR NOVAMENTE"
                onHide={() => this.onHideErrorMessage()} />
        );
    }
}